<h3 class="ui primary header">
  {{ modal.context.title }}
  <i class="link times icon" (click)="modal.deny(undefined)"></i>
</h3>

<!-- <app-warning-label></app-warning-label> -->
<div class="ui label warning-label">
  <span>
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10 7.5V10.625M17.5 10C17.5 14.1421 14.1421 17.5 10 17.5C5.85786 17.5 2.5 14.1421 2.5 10C2.5 5.85786 5.85786 2.5 10 2.5C14.1421 2.5 17.5 5.85786 17.5 10ZM10 13.125H10.0063V13.1313H10V13.125Z"
        stroke="#2C6ECB"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  </span>

  <div class="text">
    <span>Please note:</span>
    Any changes made here will be verified before it appears on your profile
  </div>
</div>

<div
  class="ui label warning-label"
  style="background-color: #fff4f4; margin-top: 20px"
  *ngIf="isBusinessName"
>
  <span>
    <img src="../../../../../assets/icons/warning-icon.svg" alt="" />
  </span>
  <div class="text">
    <span>Please note:</span>
    No changes can be made here until you have a verified FIRS Tax
    identification Number
  </div>
</div>
<div *ngIf="success || error" tamsyMargin marginY="10px">
  <esl-message-toast [(message)]="error"></esl-message-toast>
  <esl-message-toast
    [(message)]="success"
    [messageType]="'success'"
  ></esl-message-toast>
</div>
<div class="content">
  <div
    class="scroll-wrapper ui basic segment"
    [ngClass]="{ loading: pending }"
    appPadding="0"
  >
    <!--Laboratory form  -->

    <div class="ui form" [formGroup]="companyTccForm">
      <h2>Add FIRS Tax Clearance ID</h2>
      <div class="field" [ngClass]="displayFieldCss('tccNumber')">
        <label class="required">Enter your TCC ID/NO</label>
        <input
          formControlName="tccNumber"
          *ngIf="!isBusinessName"
          type="text"
          placeholder="TTC ID"
        />
        <input
          formControlName="tccNumber"
          *ngIf="isBusinessName"
          disabled
          type="text"
          placeholder="TTC ID"
        />
        <app-field-error-display
          [displayError]="isFieldValid('tccNumber')"
          errorMsg="Please enter TTC ID"
        >
        </app-field-error-display>
      </div>
    </div>
  </div>
</div>

<div class="actions" style="background: transparent; border: none">
  <button class="ui basic primary button" (click)="modal.deny(undefined)">
    Back
  </button>
  <button
    class="ui primary button"
    [ngClass]="{ yellow: pending }"
    [disabled]="pending || !companyTccForm.valid"
    (click)="submit()"
    autofocus
  >
    Done
  </button>
</div>
